import actionTypes from '../action-types';

export const setActiveTab = (tab = '', name) => ({
  type: actionTypes.SET_ACTIVE_TAB,
  tab,
  name,
});



// WEBPACK FOOTER //
// ./src/modules/utils/actions/active-tab/active-tab.actions.js